<template>
    <CRow>
        <CCol :col="(mostrarAgregarNuevoCliente)?'8':'12'">
            <CCard>
                <CCardHeader>
                    <span style="font-size: 18px;">Clientes Gesto</span>
                </CCardHeader>
                <CCardBody>
                    <CButton type="submit" class="mb-2 btn-class align-right"  
                        @click="mostrarAgregarNuevoCliente = !mostrarAgregarNuevoCliente">
                        {{mostrarAgregarNuevoCliente?"Cancelar Nuevo Cliente":"Agregar Nuevo Cliente"}}
                    </CButton>

                    <CRow>
                        <CCol col="4">
                            <CInput
                                v-tippy="getBaseTippy('Puedes buscar por los campos del cliente y también por los del usuario ;)')"
                                label="Buscar:"
                                style="margin-top:0"
                                v-model="filtroTexto"
                                type="text"
                                horizontal
                                @input="filtrarCliente"
                            />
                        </CCol>
                    </CRow>
                    
                    
                    
                    <CargandoInfo :mostrarCarga="isLoadingClientes" :mensajeInfo="'Obteniendo Información Clientes'" />
                    
                    <CRow v-for="cliente in filtrarCliente()" v-bind:key="cliente.idCliente" v-show="!isLoadingClientes">
                        <CCol>
                            <ClienteInfo :cliente="cliente" />
                        </CCol>
                    </CRow>

                </CCardBody>
                <CCardFooter>
                </CCardFooter>
            </CCard>
        </CCol>
        <CCol v-if="mostrarAgregarNuevoCliente">
            <NuevoCliente v-if="mostrarAgregarNuevoCliente" @actualizarClientes="getClientes()" />
        </CCol>
    </CRow>
    


</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";
    
    //import * as util from '@/utils'

    
    import NuevoCliente from "./Componentes/NuevoCliente.vue";
    import ClienteInfo from "./Componentes/ClienteInfo.vue";
    import { CRow } from '@coreui/vue';

    export default {
        name: "GestoMain",
        components: {
            NuevoCliente,
            ClienteInfo
        },
        data() {
            return {
                paginaActual: 1,

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                
                mostrarAgregarNuevoCliente: false,
                isLoadingClientes: false,
                clientesData: null,

                filtroTexto: '',

            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {
            this.getClientes()
        },
        methods: {
            filtrarCliente: function(){
                if(this.filtroTexto == ''){
                    return this.clientesData
                } else {
                    /*return this.clientesData.filter(item => {
                        return Object.values(item).some(val => String(val).toLowerCase().includes(this.filtroTexto.toLowerCase()));
                    });*/
                    let filtro = this.clientesData.filter(item => 
                        this.validarCampo(item.nombreCliente) ||
                        this.validarCampo(item.rutEmpresa) ||
                        this.validarCampo(this.$utils.formatearRut(item.rutEmpresa)) ||
                        this.validarCampo(item.idUnidadDrive) ||
                        this.validarCampo(item.fechaCreacion) ||
                        this.validarCampo(item.rutaCarpetaDrive) ||
                        item.usuarios.some(usuario =>
                            this.validarCampo(usuario.userName) ||
                            this.validarCampo(usuario.rutUsuario) ||
                            this.validarCampo(this.$utils.formatearRut(usuario.rutUsuario)) ||
                            this.validarCampo(usuario.nombreUsuario) ||
                            this.validarCampo(usuario.apellidoUsuario) || 
                            this.validarCampo(usuario.mailUsuario)
                        )
                    )
                    console.log("entro1", filtro)
                    return filtro
                }


            },
            validarCampo: function(campoValidar){
                if (!this.filtroTexto || !campoValidar) {
                    return false
                }

                return campoValidar.toLowerCase().includes(this.filtroTexto.toLowerCase())
            },
            getClientes: function(){
                this.isLoadingClientes = true
                var url = this.baseUrl + "/get_clientes_vapp";

                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.clientesData = result.data;
                }, error => {
                })
                .finally(() => {
                    this.isLoadingClientes = false
                });
            },


        },
    };
</script>

<style>


</style>